import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { MenuProps } from '@material-ui/core';

interface ToogleButtonMenuProps extends Omit<MenuProps, 'open'> {
  options: JSX.Element[];
  toggleMenu?: (params?: any) => any;
  mainMenuIcon?: JSX.Element;
}

const ToogleButtonMenu: React.FC<ToogleButtonMenuProps> = ({
  options,
  toggleMenu,
  mainMenuIcon,
  ...rest
}: ToogleButtonMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (toggleMenu) {
      toggleMenu();
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="toggle-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {mainMenuIcon ?? <MoreVertIcon />}
      </IconButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        id="toggle-menu"
        onClose={handleClose}
        keepMounted
        {...rest}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              if (option?.props?.onClick) {
                option.props.onClick();
              }
              handleClose();
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ToogleButtonMenu;
